import { DataSourceWithGenerics, SearchQueryFn } from "@me8eon/data_sources";
import { DataHasType } from "@me8eon/data";
import { _makeGraphApiRequest, filtersToQueryString, GraphApiContext, GraphApiFilters, GraphApiPaging, GraphApiQuery } from "./graph.api.data.sources";

export const graphApiEmails = "graphApiEmails";

export const searchBodyForEmailsGraphApi = (query: string): GraphApiQuery => {
    return {
        "requests": [
            {
                "entityTypes": ["message"],
                "query": {
                    "queryString": query.trim(),
                },
                "selectProperties": [
                    "subject",
                    "sender",
                    "toRecipients",
                    "ccRecipients",
                    "receivedDateTime",
                    "bodyPreview"
                ],
            },
        ],
    };
};

export const graphApiEmailsQuery = <Filters extends GraphApiFilters>(): SearchQueryFn<Filters, GraphApiPaging, GraphApiQuery> =>
    ({ filters }) => ({
        query: searchBodyForEmailsGraphApi(filtersToQueryString(filters)),
        filters,
    });

export function graphApiEmailsDs<Filters extends GraphApiFilters>({ graphApiUrl, token, MakeGraphApiRequest = _makeGraphApiRequest }: GraphApiContext): DataSourceWithGenerics<Filters, GraphApiPaging, GraphApiQuery, any, DataHasType[]> {
    return {
        type: graphApiEmails,
        plugin: "datasource",
        results: (devModeData, source, debug) => {
            debug("graphApiEmailsDs", devModeData);
            const hitContainers = devModeData.flatMap((d: any) => d.hitsContainers || []);
            const results = hitContainers.flatMap((d: any) => d.hits || []).map((d: any) => ({ type: "email", ...d, source }));
            return { paging: {}, results, finished: true, aggregates: {} };
        },
        query: graphApiEmailsQuery(),
        search: (query) => MakeGraphApiRequest(graphApiUrl, token, query),
    };
}
